import * as React from "react";
import NavBar from "../../components/NavBar";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {Backdrop, CircularProgress, Pagination, PaginationItem} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {ArrowBack, ArrowForward} from "@mui/icons-material";
import HandleFetchData from "../../plugin/HandleFetchData";
import {convertDate, useShowMessageComponent} from "../../assets/js/main";
import {ThemeContext} from "../../App";


export default function TicketList() {
  const {t} = useTranslation()
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {showMessageComponent} = useShowMessageComponent()
  const {fetchData} = HandleFetchData()
  const theme = React.useContext(ThemeContext)

  const [filter, setFilter] = React.useState('0');
  const [show, setShow] = React.useState(false);
  const [listTotalPage, setListTotalPage] = React.useState(null);
  const [listTicket, setListTicket] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10)
  const [pageNum, setPageNum] = React.useState(1)
  const userInfo = JSON.parse(localStorage.getItem('info-user'))

  React.useEffect(() => {
    getListTicket(pageNum)
  }, [pageNum])

  const getListTicket = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', `/v1/Ticket`, '',
       "application/json", {
         "MobileNumber": userInfo?.Mobile,
         "pageIndex": e,
         "pageSize": pageSize
       }, "postex" , "HiTicketPostexAdmin@1402"
    )
    // setItems_Invoices(fetch)
    if (fetch?.success) {
      setListTicket(fetch?.data)
      setListTotalPage(fetch?.totalCount)
    } else {
      showMessageComponent(fetch && fetch?.message, 'error')
    }
    dispatch(setLoading(false))
  }

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <NavBar blue back/>

       <div className="container">
         <div className="ticketListPage desktopSection">
           <div className="titlePage titleSection">
             <h4 className="">{t("listTicker.t1")}</h4>
             {/*<div className="filter">*/}
             {/*  <Select*/}
             {/*     id="filter"*/}
             {/*     value={filter}*/}
             {/*     onChange={(event) => setFilter(event.target.value)}*/}
             {/*     displayEmpty*/}
             {/*     inputProps={{'aria-label': 'Without label'}}*/}
             {/*  >*/}
             {/*    <MenuItem value="0">{t("listTicker.t2")}</MenuItem>*/}
             {/*    <MenuItem value="1">{t("listTicker.t3")}</MenuItem>*/}
             {/*    <MenuItem value="2">{t("listTicker.t4")}</MenuItem>*/}
             {/*  </Select>*/}
             {/*</div>*/}
           </div>

           <div className="bodyPage">

             {
               // (filter === "0" || filter === "1") &&
               listTicket?.map((item) => {
                 return (
                    <>
                      {
                        item?.comments.length > 0 &&
                        <div className="cardList" key={item?.id}>
                          <div className="title">
                            <h5>{item?.organizationName}</h5>
                            <div className="status">
                              {/*<div style={{background: '#F7941D'}}/>*/}
                              {/*<p>{t("listTicker.t3")}</p>*/}
                              <p>{item?.createdOn ? convertDate(item?.createdOn) : ''}</p>
                            </div>
                          </div>
                          <p className="date">{item?.Date}</p>
                          <h6>{t("listTicker.t5")}</h6>
                          {
                            item?.comments?.map((item) => <p key={item?.id} className="textQuestion">{item?.commentText}</p>)
                          }

                        </div>
                      }
                    </>
                 )
               })
             }
           </div>


           {listTicket?.length &&
           <div className="paginate">
             <Pagination
                count={Math.ceil(listTotalPage / pageSize)}
                page={pageNum}
                onChange={(event, value) => setPageNum(value)}
                renderItem={(item) => (
                   <PaginationItem
                      slots={{previous: ArrowBack, next: ArrowForward}}
                      {...item}
                   />
                )}
             />
           </div>
           }

         </div>

         {
           !listTicket?.length && <div className="notFindMessage">
             <img src={require('./../../assets/img/vector/1.png')} alt="vector"/>
             <p>{t("error.t2")}</p>
           </div>
         }

       </div>

     </>
  )
}
